import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { fetchHomeHits } from 'Redux/ducks/algolia-calls';
import HomePage from 'Components/HomePage/HomePage';

function HomePageContainer({ intl, siteTheme }) {
  const [apiResults, setApiResults] = useState({});
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    const doFetch = async () => {
      const results = await fetchHomeHits();
      setApiResults(results);
      setTimeout(() => {
        // Wait 5 seconds after data has been fetched before prerender can capture the render
        window.prerenderReady = true;
      }, 5000);
    };

    doFetch().catch(setFetchError);
  }, []);

  if (fetchError) {
    window.prerenderReady = true;
    throw fetchError;
  }
  return (
    <HomePage
      intl={intl}
      apiResults={apiResults}
      siteTheme={siteTheme}
    />
  );
}

const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(HomePageContainer);
